import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "global/context/Provider";
import { useContext, useState } from "react";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import { wsPostSubirOrden } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "_+_Portal/context/Provider";
import { setOrden } from "_+_Portal/_-_Autocheckin/context/action/orden";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import MotivoRechazo from "../genericos/MotivoRechazo/MotivoRechazo";
import { ContainerConfirmAutorizacion } from "./localStyle";
import { getBinario } from "global/utils/getBinario";

const ConfirmAutorizacion = ({ image, dismiss, turnoActual }) => {
  //#region -------- useState -------------
  const [loading, setLoading] = useState(false);
  //#endregion ----- useState -------------

  //#region -------- useContext -------------
  const { turnosSeleccionadosState, ordenState, pasoDispatch, ordenDispatch } =
    useContext(AutocheckContext);
  const { ordenEstudioDispatch } = useContext(PortalContext);

  //#endregion ----- useContext -------------

  //#region -------- constant -------------
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;
  const turno = listTurnosSeleccionado[turnoActual];
  //#endregion ----- constant -------------

  //#region ----------- funtions -------------
  const handleClickChangePhoto = () => {
    dismiss();
    setPaso("SubirOrden")(pasoDispatch);
  };

  const handleClickSuccess = () => {
    const ordenEstudioDto = {
      binario: getBinario(image, "png"),
      idremoto: turno.idturno,
      tag: "jpeg",
    };

    setLoading(true);
    setOrden([...ordenState.orden.data, ordenEstudioDto])(ordenDispatch);
    wsPostSubirOrden(
      [...ordenState.orden.data, ordenEstudioDto],
      handleClickChangePhoto,
      true
    )(ordenEstudioDispatch);
  };
  //#endregion -------- funtions -------------

  return (
    <ContainerConfirmAutorizacion>
      <span>
        Revise que no este movida la foto y que se vea correctamente lo
        solicitado{" "}
      </span>
      <img src={image} alt="imagen" />
      <div className="container-btn">
        <button className="danger" onClick={handleClickChangePhoto}>
          Cambiar
        </button>
        <button className="success" onClick={handleClickSuccess}>
          {loading ? <IonSpinner name="lines" /> : "Confirmar"}
        </button>
      </div>
    </ContainerConfirmAutorizacion>
  );
};
export default ConfirmAutorizacion;
